// src/components/HeadMeta.js
import { Helmet, HelmetProvider } from 'react-helmet-async';

export default function HeadMeta() {
  return (
    <Helmet>

    </Helmet>
  );
}
